// extracted by mini-css-extract-plugin
module.exports = {"labelField":"ExlyMoneyInput_labelField__2LGI_"};